import type { ChartValue } from './chart.types'

const numericMeasure = (row: ChartValue, measureKey: string): number => {
  const value = Number(row[measureKey])
  return Number.isFinite(value) ? value : 0
}

const selectTopRowsByMeasure = (
  rows: ChartValue[],
  measureKey: string,
  dataTopN: number,
): ChartValue[] => {
  const limit = Math.max(0, Math.floor(dataTopN))
  return [...rows]
    .sort(
      (left, right) =>
        numericMeasure(right, measureKey) - numericMeasure(left, measureKey),
    )
    .slice(0, limit)
}

export const ChartTopNUtils = {
  selectTopRowsByMeasure,
}
